import { useState } from "react";
import { Loader2 } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import { getUtms } from "@/lib/utm";
import { api } from "@/lib/api";

export const CheckoutButton = ({ children, testId, className = "", origen = "cta" }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const start = async () => {
    trackEvent("unirme_click", { origen });
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/checkout/session", {
        origin_url: window.location.origin,
        utm: getUtms(),
      });
      trackEvent("checkout_iniciado", { origen });
      window.location.href = data.checkout_url;
    } catch {
      setError("No se pudo iniciar el pago. Inténtalo de nuevo en unos segundos.");
      setLoading(false);
    }
  };

  return (
    <span className="inline-flex flex-col items-center">
      <button
        type="button"
        data-testid={testId}
        onClick={start}
        disabled={loading}
        className={`inline-flex items-center justify-center gap-3 rounded-full bg-gradient-to-r from-[#7C6CF0] to-[#6D8DFF] px-8 py-4 text-center text-[15px] font-bold leading-snug text-white shadow-[0_4px_24px_rgba(124,108,240,0.35)] transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_10px_32px_rgba(124,108,240,0.5)] disabled:cursor-not-allowed disabled:opacity-70 md:px-10 md:py-5 md:text-lg ${className}`}
      >
        {loading ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin" strokeWidth={2} />
            Conectando con el pago seguro…
          </>
        ) : (
          children
        )}
      </button>
      {error && (
        <span data-testid={`${testId}-error`} className="mt-3 text-sm text-red-400">
          {error}
        </span>
      )}
    </span>
  );
};
